/**
 * Suppress non-critical console warnings in production
 * while keeping errors and important warnings visible
 */

if (process.env.NODE_ENV === "production") {
  const originalWarn = console.warn;
  const originalError = console.error;

  // Suppress specific known warnings that are non-critical
  const suppressedWarnings = [
    "Warning: ReactDOM.render",
    "Warning: useLayoutEffect",
    "Warning: componentWillReceiveProps",
    "Each child in a list should have a unique",
  ];

  console.warn = function (...args) {
    const message = args[0]?.toString() || "";
    const shouldSuppress = suppressedWarnings.some((warning) =>
      message.includes(warning)
    );

    if (!shouldSuppress) {
      originalWarn.apply(console, args);
    }
  };

  // Keep all errors visible
  console.error = function (...args) {
    originalError.apply(console, args);
  };
}
